export default __webpack_public_path__ + "static/media/zazabak.991b9114.png";